module.exports = __webpack_public_path__ + "245150da21353d92582848c4597430cd.svg";